import SingUp from '../components/ComponentsSingUp/SingUp'

function singup() {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    return (
        <>
            <SingUp></SingUp>
        </>
    );
}


export default singup